export default "__VITE_ASSET__My00o1G4__"